import { useEffect, useRef } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useNavigate } from "react-router-dom";
import ModelIndex, { ModelIndexHandle } from "@components/layout/ModelIndex";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { BankAccountApi, BankAccountDataType, } from "@/api/BankAccountApi";
import { showAlert } from "@utils/Alert";
import { BANKS } from "@utils/Constants";
import { getCurrencyCode } from "@utils/Currency";
import { useAdminContext } from "@/hooks/useAdminContext";

const BankAccountsIndex = () => {
  const navigate = useNavigate();
  const modelRef = useRef<ModelIndexHandle>(null);
  const { adminTenantId, isAdminMode, profileBackUrl, adminQuerySuffix } = useAdminContext();

  useEffect(() => {
  }, []);

  const deleteRecord = async (id: string) => {
    const { errors } = await BankAccountApi.delete(id);
    if (errors?.length) {
      showAlert('danger', 'La Cuenta Bancaria no puedo ser eliminado');
    } else {
      showAlert('success', 'La cuenta Bancaria fue eliminado correctamente');
    }
    modelRef.current?.refetch();
  }

  const fetchData = (...args: any[]) =>
    isAdminMode ? BankAccountApi.fetchAllByOwnerId(adminTenantId!) : BankAccountApi.fetchAll(...args);

  return (
    <PageContainer
      title="Cuentas Bancarias"
      backUrl={profileBackUrl}
      primaryActions={[
        {
          onClick: () => {
            navigate(`/user/bank-account${adminQuerySuffix}`)
          },
          actionTitle: "Nuevo",
          color: "success"
        }
      ]}
    >
      <ModelIndex<BankAccountDataType>
        ref={modelRef}
        fetchData={fetchData}
        filterProps={[
          {
            key: "codigo",
            filterType: "eq",
            type: "number"
          },
          {
            key: "nombre",
            filterType: "contains"
          },
          {
            key: "cuenta",
            filterType: "contains"
          }
        ]}
        secondaryProperties={[
          {
            key: "bank_id",
            options: BANKS
          },
          {
            key: "nombre"
          },
          {
            key: "cuenta"
          },
          {
            key: (data) => getCurrencyCode(data.moneda),
            highlighted: true
          }
        ]}
        listActions={[
          {
            href: `/user/bank-account/{:id}${adminQuerySuffix}`,
            actionTitle: "Editar Cuenta Bancaria",
            iconProps: { icon: faEdit }
          },
          {
            actionTitle: "Eliminar Cuenta Bancaria",
            iconProps: { icon: faTrash },
            needConfirm: true,
            confirmProps: {
              title: "Eliminar Cuenta Bancaria",
              confirmMessage: "¿Seguro que desea eliminar esta cuenta Bancaria?",
              confirmBtnText: "Eliminar"
            },
            onClick: (id: string) => { deleteRecord(id) }
          }
        ]}
      >
      </ModelIndex>

    </PageContainer >
  );
}

export default BankAccountsIndex;
